import React from "react";
import strings from "../../helpers/Localization";
import CategoryChild from "./CategoryChild";
import IconComponent from "../Icons/IconComponent";

const CategoryContainer = ({ minify, isOpen, catChildrens, name, currentMenuName, specialItem, onSelectCategory, onSelectCategoryChild }) => {
    const [param, setParam] = React.useState(0);
    if (name == null) {return null;}
    const catChildren = [];
    if (catChildrens && catChildrens.length > 0) {
        catChildrens.forEach(element => {
            if (element !== null && element !== undefined && element.hasPermission) {
                if (isOpen) {
                    element.isSelected = true;
                }
                else {
                    element.isSelected = false;
                }
                catChildren.push(element);
            }
        });
    }
    return <div style={{ display: "flex", flexDirection: "column", gap: "10px", padding: "10px", width: minify ? "60%" : "calc(100% - 20px)",
        borderRadius: "6px", backgroundColor: isOpen ? "var(--carbone)" : "transparent"
    }}>
        <div
            style={{ display: "flex", width: "100%", alignItems: "center", gap: "5px", flex: "1 0 0", height: minify ? "24px" : "auto",
                cursor: isOpen ? "default" : "pointer"
            }}
            onClick={() => {
                if (onSelectCategory) {
                    onSelectCategory("reload=" + (param + 1));
                    setParam(param + 1);
                }
            }}
        >
            <IconComponent nameIcon={name} dimensions={24}
                color={isOpen ? "white" : "grey" }/>
            <span style={{ overflow: "hidden", whiteSpace: "nowrap", fontWeight: 500, color: isOpen ? "var(--white)" : "var(--carbone)", opacity: minify ? 0 : 1 }} >{strings[name]}</span>
            {
                specialItem ? specialItem : null
            }
        </div>
    </div>;

};

export default CategoryContainer;
